import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Row, Tooltip, Col, Pagination, Form} from 'antd';
import {Field, reduxForm} from "redux-form";

import Loading from '../loading/loading';
import SelectField from "../formFields/SelectField";
import TextField from "../formFields/TextField";
import SelectFieldForLoadState from "../formFields/SelectFieldForLoadState";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        width:'5%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        width:'15%',
        sorter: (a, b) => a.system_code.length - b.system_code.length
    },
    {
        title: 'عنوان شهر',
        dataIndex: 'title',
        width:'15%'
    },
    {
        title: 'نام استان',
        dataIndex: 'state',
        width:'15%'
    },
    {
        title: 'کد',
        dataIndex: 'code',
        sorter: (a, b) => a.code.length - b.code.length
    },
    {
        title: 'عملیات',
        dataIndex: 'action',
        width:'10%'
    }
  ];

class List extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:true,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            filter:[]
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)

    }

    componentWillMount() {
        this.props.getList();
        this.props.getAreaList();
    }


    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];

        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {
                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    title: list.lists[i].title,
                    state: list.lists[i].state.title,
                    code: list.lists[i].code,
                    action: <Tooltip placement="top" title="ویرایش">
                                <a href={"#/city/edit/"+list.lists[i]._id} className="listBtn"><Icon type="edit" /></a>
                            </Tooltip>
                });
            }
        }
        return dataSource;
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i}
                );

            }

        }
        return dataSource;
    }

    async __onChangeCounter(current, pageSize) {
        this.setState({size:pageSize});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList();
        this.setState({current:1})
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const { searchBoxHidden } = this.state;
        const { list } = this.props;
        var stateList = this.__getAreaStateList();

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">لیست شهر ها</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        <RTLButton className="userListBtn" shape="round" type="primary" icon="plus" href="#/city/add">
                            ایجاد شهر
                        </RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="title"
                                    component={TextField}
                                    type="text"
                                    placeholder="عنوان"
                                    onBlur={(title) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,title:title.target.value}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="stateId"
                                    component={SelectField}
                                    list={stateList}
                                    onChange={(stateId) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,stateId:stateId}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : 10)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions = {['10','20','50','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }

}

export default List = reduxForm({
    form: 'list'
})(List)
